import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import renderPenname from './utils/renderPenname';
import {
  isBrowser,
} from "react-device-detect";
class SpecialEditorTypePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSticky: false
    }
  }


  generateCategory = category => {
    category = _.unionBy(category, "_id");
    let stringBuilder = [];
    category.forEach((cat, index) => {
      if (index === 0) {
        let stringBuilder1 = (
          <a
            key={`item-category${cat._id}${index}`}
            className="mr-1"
            href={`/posts?category=${cat._id}&page=1&limit=10`}
          >
            {cat.name}
          </a>
        );
        stringBuilder.push(stringBuilder1);
      }
    });
    return stringBuilder;
  };

  generateTags = tags => {
    tags = _.unionBy(tags, "_id");
    let stringBuilder = [];
    tags.forEach((tag, index) => {
      let stringBuilder1 = (
        <a
          key={`item-tag${tag._id}${index}`}
          // className="mr-1"
          href=""
        >
          {tag.label}
        </a>
      );
      stringBuilder.push(stringBuilder1);
    });
    return stringBuilder;
  };



  render() {
    let {
      postContent: {
        title,
        description,
        content,
        categories,
        contentpenname,
        contentphoto,
        contentdesigner,
        contentvideo,
        contentsource,

        tags,
        content_background,
        content_m,
        content_image
      },
      isMobile,
      postContent
    } = this.props;
    const {
      isSticky
    } = this.state;
    if(isMobile || !isBrowser){
      let cover_m;
      if(postContent.cover_m){
        cover_m = postContent.cover_m;  
      }else{
        cover_m = postContent.img_ver;
      }
      let content_m;
      if(postContent.content_m != ""){
        content_m = postContent.content_m;
      }
      else{
        content_m = content.replaceAll("100vw","480px");
      } 
      return (
        <div id="previewpage-saostar-mobile" className="previewpage-saostar-mobile" onScroll={this.handleScroll}>
          <Helmet>
            <link
              rel="stylesheet"
              href={process.env.PUBLIC_URL + "/assets/css/style-mobile.css?v=1.4"}
            />
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=yes"/>
          </Helmet>
          <div className="previewpage-saostar layout" style={{"height":"auto"}}>
          <div id="overlay" className="overlay "></div>
          
          {/* <header ref={this.headerRef} className={"d-flex position-relative justify-content-between align-items-center border-bottom py-2 pl-1 pr-3 z--50 bg-white "}>
            <a className="logo" data-on="click" data-event-category="Header - Logo" data-event-action="click" href="/" prefetch="false">
              <img className="logo-saostar2 logo-red" src="https://ss-statics-m.saostar.vn/static/images/logo-saostar-tapchi.svg" alt="saostar.vn" />
              <img className="logo-saostar logo-white" width="176px" height="43px" src="https://ss-statics-m.saostar.vn/static/images/logo-white-saostar-tapchi.svg" alt="saostar.vn" />
            </a>
            <div className='d-flex align-items-center justify-content-between'>
              <div className="d-inline-block cursor-pointer">
                <span className="ssf-search fz26 text-red-5 "></span>
              </div>
              <button className="ham-menu ml-3 mr-1 " id="ham-4" href="#"><span></span></button>
            </div>
          </header> */}
          <div id="articlepage" className="main-layout bg-grey-3">
            <div className="">
            <article className="editor-type-special" style={{"height": "auto",backgroundImage: `url(${postContent.content_image})`,
            backgroundColor: `${postContent.content_background}`}}>
              {cover_m &&
                <img src={cover_m} alt="" className="w-100" />
              }
              <div>
                {content_m ? (
                    <div
                      itemProp="articleBody"
                      className="art-content px-3"
                      dangerouslySetInnerHTML={{ __html: content_m }}
                    />
                  ) : (
                      <center>
                        <em>Add your custom block in the editor</em>
                      </center>
                    )}
                
              </div>
              <div className="pt-3 pb-3 bg-white">
                <div className="mt-4 px-3 text-right d-flex justify-content-flex-end mx-auto w-95">
                    {postContent.contentpenname &&
                      <div className="fz16 fw-bold leading-20px"><p className="fw-normal fz12px leading-20px">Bài viết</p><p className="leading-20px">{renderPenname(postContent.contentpenname)}</p></div>
                    }
                    {postContent.contentdesigner &&
                      <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Thiết kế</p><p className="leading-20px">{postContent.contentdesigner.label}</p></div>
                    }
                    {postContent.contentphoto &&
                      <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Photo</p><p className="leading-20px">{postContent.contentphoto.label}</p></div>
                    }
                    {postContent.contentvideo &&
                      <div className="fz16 fw-bold ml-4 leading-20px"><p className="fw-normal fz12px leading-20px">Video</p><p className="leading-20px">{postContent.contentvideo.label}</p></div>
                    }
                  </div>
                  <div className="mt-1 text-right">
                    {postContent.contentsource &&
                      <span className="fz16 fw-bold">Theo {postContent.contentsource.label}</span>
                    }
                  </div>
                  <div className="art-tag mt-6 mx-3">
                    <span className="ssf-tag mr-2 text-grey-9 fz20px t--7 position-relative"></span>
                    {postContent.tags && postContent.tags.map((tag, idx) =>
                      <h3 className="d-inline-block"><a key={`art-tag-${idx}`} href={`/tag/${tag.slug}/`} prefetch="false" className="tag-tab mb-1 mr-1">{tag.label}</a></h3>
                    )}
                  </div>
              </div>
              <div className="d-flex mt-4 mb-0 w-100 px-3 pb-4"><div className="w-50 justify-content-center text-grey-13 px-2 py--10 rounded--4 mr-2 fz12 cursor-pointer d-flex align-items-center border-grey-11"><span className="ssf-copylink mr-1"></span><span className="label-copylink"></span></div><div className="text-grey-13 px-2 py--10 w-50 justify-content-center rounded--4 fz12 cursor-pointer d-flex align-items-center border-grey-11"><span className="ssf-facebook mr-1"></span><span>Chia sẻ</span></div></div>
            </article>
            </div>
          </div>

          </div>
      </div>
      );
    }
    else{
      let cover_pc;
      if(postContent.cover_pc){
        cover_pc = postContent.cover_pc;  
      }
      return (
        <div className="previewpage-saostar" >
          <Helmet>
            <link
              rel="stylesheet"
              href={process.env.PUBLIC_URL + "/assets/css/style.css"}
            />
            <link
              rel="stylesheet"
              href={process.env.PUBLIC_URL + "/assets/css/article_special.css?v=2372020"}
            />
          </Helmet>
          {/* <header className="bg-white border-bottom-3-red py-2 px-4 d-flex justify-content-between align-items-center shadow-sm position-sticky z--100 t--0">
            <div className="w--1200 ma d-flex justify-content-between align-items-center">
                <div className="d-flex w-80">
                  <a href="/" prefetch="false">
                    <img src={process.env.PUBLIC_URL + "/assets/images/logo-saostar.svg"} alt="" className="w--100" />
                  </a>
                  <div className="d-flex align-items-center mt--2 ml-4">
                    <a className="py-1 fz14 ff-bold pr-3 border-right" href="/tag/special/" prefetch="false">
                      SPECIAL
                    </a>
                    <h1 className="pl-3 fw-600 fz14">{title}</h1>
                  </div>
                </div>
                <div className="w-10">
                  <img src="/assets/images/btncopylink.png"/>
                </div>
            </div>
          </header> */}
          <article className="special-editor-type pb-6" style={{ backgroundColor: content_background, backgroundImage: `url(${content_image})` }}

          >

            {/* <h1 className="article-title">{title || "Chưa có tiêu đề"}</h1> */}

            <div className="article-content w-100">
              <div className="">
                {/* <h3 className="sapo">{description}</h3> */}

                <div style={{ backgroundColor: content_background, backgroundImage: `url(${content_image})` }}
                >
                  {cover_pc &&
                    <img src={cover_pc} alt="" className="w-100" />
                  }
                  {content ? (
                    <div
                      className="content"
                      dangerouslySetInnerHTML={{ __html: content }}
                    />
                  ) : (
                      <center>
                        <em>Add your custom block in the editor</em>
                      </center>
                    )
                  }

                </div>

                <div className="w--780 ma mt---50 bg-white p-4 rounded">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="w-100 d-flex">
                    {contentpenname &&
                      <div className="text-left ml-4 mr-4">
                        <p className="fz12 ff-regular text-grey-7">BÀI VIẾT</p>
                        <p className="fz14 fw-bold mt-1">{renderPenname(contentpenname)}</p>
                      </div>
                    }
                    {contentphoto &&
                      <div className="text-left ml-4 mr-4">
                        <p className="fz12 ff-regular text-grey-7">PHOTO</p>
                        <p className="fz14 fw-bold mt-1">{contentphoto.label}</p>
                      </div>
                    }
                    {contentdesigner &&
                      <div className="text-left ml-4 mr-4">
                        <p className="fz12 ff-regular text-grey-7">THIẾT KẾ</p>
                        <p className="fz14 fw-bold mt-1">{contentdesigner.label}</p>
                      </div>
                    }
                    {contentvideo &&
                      <div className="text-left ml-4 mr-4">
                        <p className="fz12 ff-regular text-grey-7">VIDEO</p>
                        <p className="fz14 fw-bold mt-1">{contentvideo.label}</p>
                      </div>
                    }
                    {contentsource &&
                      <div className="text-left ml-4 mr-4">
                        <p className="fz12 ff-regular text-grey-7">THEO</p>
                        <p className="fz14 fw-bold mt-1">{contentsource.label}</p>
                      </div>
                    }
                  </div>
                  <img src="/assets/images/btncopylink.png" style={{"width":"160px"}}/>
                </div>
                <div className="text-center border-top w-100 art-tag mt---20 pt---10">
                  <span className="fz18 pt-1 align-sub ff-regular text-uppercase text-grey-7 mr-2 ssf-tag"></span>
                  {tags && tags.map((tag, idx) =>
                    <a key={`art-tag-${idx}`} href={`/tag/${tag.slug}/`} prefetch="false" className="tag-tab mb-1 mr-1">{tag.label}</a>
                  )}
                </div>
              </div>
              </div>

            </div>
          </article>
        </div>
      );
    }
    
  }
}


SpecialEditorTypePage.propTypes = {

};


export default SpecialEditorTypePage;
